import "./GlamourKitty.module.css";
import Header from "@/reusable_sections/Header";
import HeroArtwork from "./sections/HeroArtwork";
import VersionToggleStreamingPlatforms from "./sections/VersionToggleStreamingPlatforms";
import TheLarderTheLand from "./sections/TheLarderTheLand";
import Footer from "@/reusable_sections/Footer";
export default function GlamourKittyPage() {
  return <div>
      <Header />
      <HeroArtwork />
      <VersionToggleStreamingPlatforms />
      <TheLarderTheLand />
      <Footer />
    </div>;
}